export default "__VITE_ASSET__BjCY5x_D__"